import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { allMusic, totalTrackCount } from "../../musicPageData";

const PAGE_SIZE = 12;

export default function AllMusicGrid({ searchQuery, activeGenre }) {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  const filtered = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return allMusic.filter((track) => {
      const matchesGenre = activeGenre === "All" || track.genre === activeGenre;
      const matchesQuery =
        !q ||
        track.title.toLowerCase().includes(q) ||
        track.artist.toLowerCase().includes(q) ||
        track.genre.toLowerCase().includes(q);
      return matchesGenre && matchesQuery;
    });
  }, [searchQuery, activeGenre]);

  const visibleTracks = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < filtered.length;

  return (
    <section className="mu-section pt-4">
      <div className="container">
        <div className="d-flex justify-content-between align-items-end flex-wrap gap-2 mb-4">
          <h2 className="section-title mb-0">All Music</h2>
          <span className="track-meta">
            Showing {visibleTracks.length} of {filtered.length === allMusic.length ? totalTrackCount : filtered.length} tracks
          </span>
        </div>

        {visibleTracks.length === 0 ? (
          <p className="section-sub">No tracks match your search. Try a different title, artist, or genre.</p>
        ) : (
          <div className="row g-4">
            {visibleTracks.map((t) => (
              <div className="col-6 col-md-4 col-lg-2" key={t.id}>
                <Link to={`/music/${t.slug}`} className="track-card-link">
                  <div className="track-card">
                    <div className="track-art">
                      <img src={t.img} alt={t.title} />
                      <div className="vinyl">
                        <div className="vinyl-disc"></div>
                      </div>
                      <span className="track-genre-badge">{t.genre}</span>
                    </div>
                    <div className="track-info">
                      <div className="track-title">{t.title}</div>
                      <div className="track-meta">{t.artist}</div>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}

        {hasMore && (
          <div className="text-center mt-5">
            <button
              className="btn-mu-outline"
              onClick={() => setVisibleCount((c) => c + PAGE_SIZE)}
            >
              Load More Tracks
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
